import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CorrespondenceIssuedCategoryStoreActions,
  CorrespondenceIssuedCategoryStoreSelectors,
  CorrespondenceIssuedCategoryStoreReducer,
} from './index';
import { CorrespondenceIssuedCategoryDto } from '@cradua/data';

@Injectable()
export class CorrespondenceIssuedCategoryFacade {
  constructor(
    private store: Store<
      CorrespondenceIssuedCategoryStoreReducer.CorrespondenceIssuedCategoryPartialState
    >
  ) {}

  correspondenceIssuedCategory$ = this.store.select(
    CorrespondenceIssuedCategoryStoreSelectors.getSelected
  );
  correspondenceIssuedCategoryError$ = this.store.select(
    CorrespondenceIssuedCategoryStoreSelectors.getCorrespondenceIssuedCategoryError
  );

  getselected() {
    return this.store.select(
      CorrespondenceIssuedCategoryStoreSelectors.getSelected
    );
  }

  get isLoadingCorrespondenceIssuedCategory() {
    this.store.dispatch(
      CorrespondenceIssuedCategoryStoreActions.loadCorrespondenceIssuedCategory()
    );
    return this.store.select(
      CorrespondenceIssuedCategoryStoreSelectors.loadingCorrespondenceIssuedCategory
    );
  }

  get loadCorrespondenceIssuedCategory() {
    this.store.dispatch(
      CorrespondenceIssuedCategoryStoreActions.loadCorrespondenceIssuedCategory()
    );
    return this.store.select(
      CorrespondenceIssuedCategoryStoreSelectors.getAllCorrespondenceIssuedCategory
    );
  }

  addCorrespondenceIssuedCategory(
    newCorrespondenceIssuedCategory: CorrespondenceIssuedCategoryDto[]
  ) {
    this.store.dispatch(
      CorrespondenceIssuedCategoryStoreActions.addCorrespondenceIssuedCategory({
        newCorrespondenceIssuedCategory,
      })
    );
  }

  updateCorrespondenceIssuedCategory(
    updateCorrespondenceIssuedCategory: CorrespondenceIssuedCategoryDto[]
  ) {
    this.store.dispatch(
      CorrespondenceIssuedCategoryStoreActions.updateCorrespondenceIssuedCategory(
        { updateCorrespondenceIssuedCategory }
      )
    );
  }

  removeCorrespondenceIssuedCategory(ids: string[]) {
    this.store.dispatch(
      CorrespondenceIssuedCategoryStoreActions.removeCorrespondenceIssuedCategory(
        { ids }
      )
    );
  }
}
